export function getAnalyticsScreenName(serviceGroup) {
  return `serviceGroupScreen : ${serviceGroup.id} : ${serviceGroup.name}`
}
